import { render, staticRenderFns } from "./click-malawi.vue?vue&type=template&id=1bf20ef0"
import script from "./click-malawi.vue?vue&type=script&lang=js"
export * from "./click-malawi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports